<script>
   /*************************************************************/
   /* Root component for an application                         */
   /*************************************************************/

   export let WASM;
   export let appTitle;
   export let appShortTitle;
   export let appSlogan;
   export let containers = [];
   export let isBeta = false;

   let selectedContainer = 0;

   let isInfoShown = false;
   function showInfo() {
      isInfoShown = true;
   }

   function closeInfo() {
      isInfoShown = false;
   }

   function selectContainer(id) {
      selectedContainer = id;
   }
</script>

<div class="page">

   <header class="page-header">
      <div class="header-group">
         <img class="logo" alt={appShortTitle} src="logo.svg" />
         <h1>{appTitle}{#if isBeta}<sup style="color:red">β</sup>{/if}</h1>
         <p>{appSlogan}</p>
      </div>
      <ul class="nav">
         {#each containers as container, i}
         <li class="nav-item" class:selected={selectedContainer === i} >
            <button on:click={() => selectContainer(i)} on:keydown={() => selectContainer(i)}>{container.name}</button>
         </li>
         {/each}
      </ul>
   </header>

   <main>
      {#each containers as container, i}
      <div class:hidden={selectedContainer !== i} class="app-container">
      <svelte:component this={container.container} {WASM} />
      </div>
      {/each}
   </main>

   <footer>
      <button class="button-info" on:click={showInfo} on:keydown={showInfo}>info</button>
      <slot name="footer">
      </slot>
   </footer>

   {#if isInfoShown}
   <div class="info-backdrop">
      <div class="info-container">
         <button class="info-close-button" on:click={closeInfo}>✕</button>
         <slot>
         </slot>
      </div>
   </div>
   {/if}
</div>

<style>

   .page {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 0;

      min-width: 1020px;
      min-height: 590px;
      max-width: 1900px;

      display: flex;
      flex-direction: column;
   }

   header{
      display: flex;
      justify-content: flex-start;
      flex-direction: row;
      background: #f8f6f4;
   }

   .header-group {
      width: min-content;
      min-width: 400px;
      margin: 0 0 0 0.25rem;
      display: grid;
      align-items: center;
      grid-template-columns: min-content 1fr;
      grid-template-rows: min-content min-content min-content min-content;
      grid-template-areas:
         "logo ."
         "logo title"
         "logo subtitle"
         "logo .";
   }

   .logo{
      width: 5rem;
      margin: 0.25rem;
      grid-area: logo;
   }

   .header-group > h1{
      margin: 0;
      padding: 0;
      text-align: left;
      font-size: 1.6rem;
      color: #4e5052;
      white-space: nowrap;
      grid-area: title;
   }

   .header-group > p{
      margin: 0;
      padding: 0;
      text-align: left;
      font-size: 1.1rem;
      color: #7e8082;
      grid-area: subtitle;
   }

   main{
      flex-basis: auto;
      flex-grow: 1;
      flex-shrink: 1;
      box-sizing: border-box;
      padding: 0.2rem 0;
   }

   main > div{
      height: 100%;
   }

   footer {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.9rem;
      flex-basis: min-content;
      flex-grow: 0;
      flex-shrink: 0;
      background: #4e5052;
      color: #c0c0c0;
      padding: 0.5em;
   }

   footer :global(p) {
      max-width: 800px;
      text-align: center;
      margin: 0 auto;
      padding: 0.15em;
   }

   footer :global(span),
   footer :global(a) {
      color: #f8ebc5
   }

   .hidden {
      display: none;
   }

   .nav,
   .nav * {
      user-select: none;
      -moz-user-select: none;
   }

   .nav {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      list-style: none;
      margin: 0 100px 0 auto;
      padding: 0;
      align-self: flex-end;
   }

   .nav-item {
      list-style: none;
      margin: 0 2px;
      border-bottom: 5px solid transparent;
   }

   .nav-item > button {
      cursor: pointer;
      padding: 0.5em 1em;
      border: none;
      box-shadow: none;
      background: transparent;
      font-size: inherit;
   }

   .nav-item > button > :global(span) {
      color: #888;
   }

   .nav-item.selected {
      border-bottom: 5px solid #80888f;
   }

   .nav-item.selected > button{
      font-weight: bold;
      cursor: default;
   }

   .nav-item.selected:hover {
      border-bottom: 5px solid #80888f;
   }


   @media (min-width: 1600px) {
      .page > header {
         border-bottom-right-radius: 0.25rem;
         border-bottom-left-radius: 0.25rem;
      }

      .page > footer {
         border-top-right-radius: 0.25rem;
         border-top-left-radius: 0.25rem;
      }
   }

   .button-info {
      cursor: pointer;
      border: none;
      box-shadow: none;
      background: transparent;
      font-weight: bold;
      color: #4e5052;
      border-radius: 0.2em;

      padding: 0.25em 0.5em;
      text-align: center;
      line-height: 1em;
      margin-left: 0.25em;
      margin-right: 0.5em;
      background-color: #f8ebc5;
   }

   .info-backdrop{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000000a0;
      z-index: 100;

      display: flex;
      justify-content: center;
      align-items: flex-start;
   }

   .info-container {
      position: relative;
      top: 10%;
      width: 100%;
      max-width: 940px;
      max-height: 600px;
      background-color: #f8f6f4;
      border-radius: 0.25rem;
      padding: 1rem;
      z-index: 101;
   }

   .info-container > :global(p) {
      font-size: 1.15em;
      line-height: 1.35em;
      padding: 0 1em 0.5em 1em;
      margin: 0;
   }

   .info-container > :global(.release-info) {
      font-size: 1em;
      color: #808080;
      line-height: 1.25em;
      padding: 0 1.2em 0.5em 1.2em;
      margin: 0;
   }

   .info-container > :global(h2) {
      font-size: 1.5em;
      line-height: 1.25em;
      padding: 0.5em 1rem 0.5em 1rem;
      margin: 0;
   }

   .info-container > :global(h3) {
      font-size: 1.15em;
      line-height: 1.25em;
      padding: 1rem 1em 0.25em 1em;
      margin: 0;
   }

   .info-container > :global(ul) {
      margin: 0;
   }

   .info-container > :global(ul > li) {
      font-size: 1.15em;
      line-height: 1.25em;
      padding: 0 0.5em 0.5em 0em;
      margin: 0;
   }

   .info-container > :global(ul > li > span) {
      font-size: 0.9em;
      color: #808080;
      line-height: 1.25em;
      padding: 0 0.25em;
      margin: 0;

   }

   .info-container :global(a) {
      color: #ae8032;
   }

   .info-container :global(a:hover) {
      color: #eb9707;
   }

   .info-close-button {
      cursor: pointer;
      border: none;
      box-shadow: none;
      background: transparent;
      font-size: inherit;
      font-weight: bold;
      color: #f8ebc5;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      background-color: #9ea0a2;
      float: right;
      text-align: center;
      padding: 0;
      line-height: 20px;
      font-size: 12px;
   }

   .info-close-button:hover {
      background-color: #4e5052;
   }

   .info-container:last-child {
      padding-bottom: 2rem;
   }


</style>